import React from 'react';
import { Search, X } from 'lucide-react';

interface DataTableHeaderProps {
  title?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  filters?: React.ReactNode;
  actions?: React.ReactNode;
}

export const DataTableHeader: React.FC<DataTableHeaderProps> = ({
  title,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters,
  actions,
}) => {
  return (
    <>
      {/* Header with title, search, and actions */}
      <div className="p-6 border-b border-gray-100 dark:border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
        {title && <h3 className="font-bold text-gray-800 dark:text-white text-lg">{title}</h3>}

        <div className="flex w-full md:w-auto gap-3">
          {/* Search input */}
          <div className="relative flex-1 md:w-64">
            <input
              type="text"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={searchPlaceholder}
              className="w-full pl-9 pr-9 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500"
            />
            <Search className="absolute left-3 top-2.5 text-gray-400" size={16} />
            {searchValue && (
              <button
                type="button"
                onClick={() => onSearchChange('')}
                className="absolute right-2.5 top-2 p-0.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors"
              >
                <X size={14} />
              </button>
            )}
          </div>

          {/* Actions (Create button, etc.) */}
          {actions}
        </div>
      </div>

      {/* Filters section if present */}
      {filters && (
        <div className="p-4 bg-gray-50 dark:bg-gray-800/50 border-b border-gray-100 dark:border-gray-800 flex flex-wrap items-center gap-3">
          {filters}
        </div>
      )}
    </>
  );
};
